import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

const NotFound = () => {
  const navigate = useNavigate();
  useEffect(() => {
    navigate('/');

    //eslint-disable-next-line
  }, []);
  return <h1>404</h1>;
};

export default NotFound;
